import { ComparePopup } from "./compare/cmp"
import { DatalayersCtrl } from "./datalayers"
import { LayerDetailsCtrl } from "./details/details"
import { PerfDistributionCtrl } from "./distribution/perf/perf"
import { TerramapDistributionCtrl } from "./distribution/terramap/terramap"
import { YieldDistributionCtrl } from "./distribution/yield/yield"
import { CopyLayerCtrl } from "./edit/copy/copy"
import { EditLayerCtrl } from "./edit/edit"
import { GenericPlanCtrl } from "./edit/genplan/genplan"
import { CreateGridCtrl } from "./edit/grid/grid"
import { SimplifyPopup } from "./edit/simplify/popup"
import { simplify } from "./edit/simplify/simplify"
import { YieldRecalibrateCtrl } from "./edit/yield/recalibrate"
import { GeorefCtrl } from "./georef/georef"
import { GeorefService } from "./georef/service"
import { GenplanLayer } from "./map/genplanLayer"
import { DatalayersMapFactory } from "./map/mapFactory"
import { PictureLayer } from "./map/pictureLayer"
import { PicturePopup } from "./map/pictures/popup"
import { GenericPlanViewer } from "./map/viewers/genericPlan"
import { PrescriptionPlanViewer } from "./map/viewers/prescriptionPlan"
import { BrowserCtrl } from "./menu/browser/browser"
import { ContextMenuCtrl } from "./menu/cxm/cxm"
import { MenuCtrl } from "./menu/menu"
import { TreeCtrl } from "./menu/tree"
import { ViewerCtrl } from "./menu/viewer"
import { LayerManagerCtrl } from "./mgr/mgr"
import { DatalayerFactoryProvider, DatalayersApiLoaderProvider, DatalayerViewManagerProvider, DrawingLayer, LayerTypeId, MapDependencies, YieldMapViewer } from "./omnia"
import { BoundariesCtrl } from "./satellite/boundaries/boundaries"
import { LayersCtrl } from "./satellite/layers/layers"
import { MainCtrl } from "./satellite/main/main"
import { FieldLayerLoader } from "./services/fieldLayerLoader"
import { DatalayersService } from "./services/service"
import { YieldScalesCreateDialog } from "./yield-scales/create/create"
import { YieldScalesCtrl } from "./yield-scales/yield-scales"
import { YieldScalePopupCtrl } from "./yield-scales/yield-scales-popup"

export function setup(module: ng.IModule) {

    module

        .provider("OmniaDatalayersApiLoader", DatalayersApiLoaderProvider)

        .service("OmniaDatalayersService", DatalayersService)
        .service("OmniaDatalayersGeorefService", GeorefService)

        .provider("OmniaDatalayersFactory", DatalayerFactoryProvider)
        .service("OmniaDatalayersMapFactory", DatalayersMapFactory)

        .provider("OmniaDatalayersViewManager", DatalayerViewManagerProvider)

        .service("OmniaDatalayersDependencies", MapDependencies)

        .service("OmniaFieldLayerLoader", FieldLayerLoader)

        .directive("omniaDatalayers", DatalayersCtrl.create)

        .directive("omniaDatalayersMenu", MenuCtrl.create)
        .directive("omniaDatalayersMenuTree", TreeCtrl.create)
        .directive("omniaDatalayersMenuViewer", ViewerCtrl.create)
        .directive("omniaDatalayersMenuCxm", ContextMenuCtrl.create)
        .directive("omniaDatalayersBrowser", BrowserCtrl.create)

        .directive("omniaMaplayerComparePopup", ComparePopup.create)

        .directive("omniaYieldLayerDistribution", YieldDistributionCtrl.create)
        .directive("omniaPerfLayerDistribution", PerfDistributionCtrl.create)
        .directive("omniaTerramapLayerDistribution", TerramapDistributionCtrl.create)

        .directive("omniaDatalayersLayerEdit", EditLayerCtrl.create)
        .directive("omniaDatalayersLayerCopy", CopyLayerCtrl.create)
        .directive("omniaDatalayersCreateGrid", CreateGridCtrl.create)
        .directive("omniaDatalayersEditYieldRecalibrate", YieldRecalibrateCtrl.create)
        .directive("omniaMaplayersEditGenericPlan", GenericPlanCtrl.create)
        .directive("omniaMaplayerSimplifyPopup", SimplifyPopup.create)

        .directive("omniaDatalayersDetails", LayerDetailsCtrl.create)

        .directive("omniaDatalayersManager", LayerManagerCtrl.create)

        .directive("omniaMaplayersEditGeoref", GeorefCtrl.create)

        .directive("omniaMaplayersEditYieldScalesPopup", YieldScalePopupCtrl.create)
        .directive("omniaMaplayersEditYieldScales", YieldScalesCtrl.create)
        .directive("omniaMaplayersEditYieldScalesCreateDialog", YieldScalesCreateDialog.create)

        .directive("omniaMaplayersPicturePopup", PicturePopup.create)

        .directive("omniaSatelliteMain", MainCtrl.create)
        .directive("omniaSatelliteBoundaries", BoundariesCtrl.create)
        .directive("omniaSatelliteLayers", LayersCtrl.create)

        ;


    module.config(["OmniaDatalayersViewManagerProvider", (provider: DatalayerViewManagerProvider) => {

        provider.register([
            YieldMapViewer.createFactory(),
            YieldMapViewer.createYieldAverageFactory(),
            GenericPlanViewer.createFactory(),
            PrescriptionPlanViewer.createFactory()
        ])

    }])

    module.config(["OmniaDatalayersFactoryProvider", "omniaApiUrl", (provider: DatalayerFactoryProvider, apiUrl: string) => {

        provider.register(LayerTypeId.Drawing, (layer, ctxt) => new DrawingLayer(layer, ctxt))
        provider.register(LayerTypeId.Picture, (layer, ctxt) => new PictureLayer(layer, ctxt, apiUrl))
        provider.register(LayerTypeId.GenericPlan, (layer, ctxt) => new GenplanLayer(layer, ctxt))

    }]);

}
